import EpisodeConfig, {
  Visibility,
} from '../../../domain/value_objects/EpisodeConfig';

export interface EpisodeConfigData {
  enabled_zoom: boolean;
  visibility: Visibility;
}

export default class EpisodeConfigMapper {
  public map(obj: EpisodeConfigData): EpisodeConfig {
    return new EpisodeConfig(obj.enabled_zoom, obj.visibility);
  }
}
